<template>
  <div>
    <EmployeeDashboard v-if="isEmployee" />
    <CustomerDashboard v-else-if="isCustomer" />
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import EmployeeDashboard from '../components/EmployeeDashboard.vue'
import CustomerDashboard from '../components/CustomerDashboard.vue'
import { useAuth } from '@/composables/useAuth'

useHead({
  title: 'Dashboard',
})

const { isEmployee, isCustomer } = useAuth()
</script>
